
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import PendoIconOption from './pendo-icon-option.js';
import PendoGroupOption from './pendo-group-option.js';

var script = {
  name: 'PendoCheckboxOption',
  components: {
    PendoGroupOption,
    PendoIconOption
  },
  props: {
    option: {
      type: [Object, String],
      required: true
    },
    type: {
      type: String,
      default: 'icon',
      validator: type => ['icon', 'group'].includes(type)
    }
  },
  inject: ['multiselect'],
  computed: {
    isChecked() {
      return this.multiselect.isOptionSelected(this.option);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g(_vm._b({
    staticClass: "pendo-multiselect-option--checkbox"
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_c('span', {
    staticClass: "pendo-multiselect-option__input",
    class: {
      'is-checked': _vm.isChecked
    }
  }, [_c('span', {
    staticClass: "pendo-multiselect-option__inner"
  })]), _vm._v(" "), _vm._t("default", [_vm.type === 'icon' ? _c('pendo-icon-option', {
    attrs: {
      "option": _vm.option
    }
  }) : _vm._e(), _vm._v(" "), _vm.type === 'group' ? _c('pendo-group-option', {
    attrs: {
      "option": _vm.option
    }
  }) : _vm._e()])], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-checkbox-option.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoCheckboxOption = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoCheckboxOption;
